// material
import { Stack } from "@mui/material";
import "./Education.css";

// ----------------------------------------------------------------------

export default function EducationSub() {
  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      sx={{ borderBottom: "1px solid #ffffff80" }}
    >
      <Stack
        justifyContent="center"
        alignItems="center"
        sx={{
          borderRight: "1px solid #ffffff80",
          width: { xs: "100%", md: "37%" },
          p: { xs: "7%", md: "0" },
        }}
      >
        <p className="es_txt">STEP BY STEP GUIDE</p>
      </Stack>
      <Stack
        alignItems="center"
        justifyContent="center"
        sx={{
          borderRight: "1px solid #ffffff80",
          width: { xs: "100%", md: "46%" },
        }}
      >
        <img
          src="/assets/subimg.png"
          style={{ width: "100%", height: "100%" }}
        />
      </Stack>
    </Stack>
  );
}
